"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeaponComponent = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _gameObject = /*#__PURE__*/new WeakMap();
var _inputComponent = /*#__PURE__*/new WeakMap();
var _bulletGroup = /*#__PURE__*/new WeakMap();
var _fireBulletInterval = /*#__PURE__*/new WeakMap();
var _bulletConfig = /*#__PURE__*/new WeakMap();
var _eventBusComponent = /*#__PURE__*/new WeakMap();
// Converted to TypeScript

class WeaponComponent {
  // EventBusComponent

  constructor(gameObject, inputComponent,
  // InputComponent
  bulletConfig, eventBusComponent) {
    _classPrivateFieldInitSpec(this, _gameObject, void 0);
    _classPrivateFieldInitSpec(this, _inputComponent, void 0);
    // InputComponent
    _classPrivateFieldInitSpec(this, _bulletGroup, void 0);
    _classPrivateFieldInitSpec(this, _fireBulletInterval, void 0);
    _classPrivateFieldInitSpec(this, _bulletConfig, void 0);
    _classPrivateFieldInitSpec(this, _eventBusComponent, void 0);
    _classPrivateFieldSet(_gameObject, this, gameObject);
    _classPrivateFieldSet(_inputComponent, this, inputComponent);
    _classPrivateFieldSet(_bulletConfig, this, bulletConfig);
    _classPrivateFieldSet(_eventBusComponent, this, eventBusComponent);
    _classPrivateFieldSet(_fireBulletInterval, this, 0);
    _classPrivateFieldSet(_bulletGroup, this, _classPrivateFieldGet(_gameObject, this).scene.physics.add.group({
      name: "bullets-".concat(Phaser.Math.RND.uuid()),
      enable: false
    }));
    _classPrivateFieldGet(_bulletGroup, this).createMultiple({
      key: 'bullet',
      quantity: _classPrivateFieldGet(_bulletConfig, this).maxCount,
      active: false,
      visible: false
    });
    _classPrivateFieldGet(_gameObject, this).scene.physics.world.on(Phaser.Physics.Arcade.Events.WORLD_STEP, this.worldStep, this);
    _classPrivateFieldGet(_gameObject, this).once(Phaser.GameObjects.Events.DESTROY, () => {
      _classPrivateFieldGet(_gameObject, this).scene.physics.world.off(Phaser.Physics.Arcade.Events.WORLD_STEP, this.worldStep, this);
    }, this);
  }
  get bulletGroup() {
    return _classPrivateFieldGet(_bulletGroup, this);
  }
  update(dt) {
    _classPrivateFieldSet(_fireBulletInterval, this, _classPrivateFieldGet(_fireBulletInterval, this) - dt);
    if (_classPrivateFieldGet(_fireBulletInterval, this) > 0) {
      return;
    }
    if (_classPrivateFieldGet(_inputComponent, this).shootIsDown) {
      const bullet = _classPrivateFieldGet(_bulletGroup, this).getFirstDead();
      if (bullet === undefined || bullet === null) {
        return;
      }
      const x = _classPrivateFieldGet(_gameObject, this).x;
      const y = _classPrivateFieldGet(_gameObject, this).y + _classPrivateFieldGet(_bulletConfig, this).yOffset;
      bullet.enableBody(true, x, y, true, true);
      bullet.body.velocity.y -= _classPrivateFieldGet(_bulletConfig, this).speed;
      bullet.setState(_classPrivateFieldGet(_bulletConfig, this).lifespan);
      bullet.play('bullet');
      bullet.setScale(0.8);
      bullet.body.setSize(14, 18);
      bullet.setFlipY(_classPrivateFieldGet(_bulletConfig, this).flipY);
      _classPrivateFieldSet(_fireBulletInterval, this, _classPrivateFieldGet(_bulletConfig, this).interval);
      _classPrivateFieldGet(_eventBusComponent, this).emit('SHIP_SHOOT');
    }
  }
  worldStep(delta) {
    _classPrivateFieldGet(_bulletGroup, this).getChildren().forEach(bullet => {
      if (!bullet.active) {
        return;
      }
      bullet.state -= delta;
      if (bullet.state <= 0) {
        bullet.disableBody(true, true);
      }
    });
  }
  destroyBullet(bullet) {
    bullet.setState(0);
  }
}
exports.WeaponComponent = WeaponComponent;